import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SecondaryNav from "./SecondaryNav.js";
import { FaEnvelope } from 'react-icons/fa';
import { axiosInstance } from '../utils/axiosInterceptor.js';
import { useGeneralInfo } from '../utils/GeneralnfoContext.js';
import { FaHome } from "react-icons/fa";
import { RiAdminFill } from "react-icons/ri";
import { HiMiniComputerDesktop } from "react-icons/hi2";
import { BsFillBoxSeamFill } from "react-icons/bs";
import { RiArrowGoBackFill } from "react-icons/ri";
import { FaUserCircle } from "react-icons/fa";
import { CiCircleMore } from "react-icons/ci";
import { FaBars } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';

const Nav = () => {
    const { t } = useTranslation();
    const videoRef = useRef(null);
    const [videoSrc, setVideoSrc] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [messages, setMessage] = useState([]);
    const [punish, setPunish] = useState([]);
    const [isInputDisabled, setIsInputDisabled] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));
    const selectWorkingPart = localStorage.getItem('LastOpenMenu');
    const currentName = user?.UserName;
    const apiUrl = process.env.REACT_APP_API_URL;
    const [password, setPassword] = useState('');
    const [secondaryBar, setSecondaryBar] = useState(selectWorkingPart);
    const [primaryTab, setPrimaryTab] = useState(selectWorkingPart);
    const [phoneShowMore, setPhoneShowMore] = useState(false);
    const navDispatcherSubNavRef = useRef(null);
    const navAdminSubNavRef = useRef(null);
    const navFrontDeskSubNavRef = useRef(null);
    const navInspectorSubNavRef = useRef(null);
    const phoneMoreBtnRef = useRef(null);

    // Location code info
    const { selectedLocation, setSelectedLocation, locationData, setLocationData, returnFunction, setTargetReturn, devices } = useGeneralInfo();
    const [openMenu, setOpenMenu] = useState(devices > 1 ? true : false);
    const handleVolumeAndPlayState = () => {
        if (videoRef.current) {
            const isVolumeMax = videoRef.current.volume === 1 && !videoRef.current.muted;
            setIsInputDisabled(!(isVolumeMax && isPlaying));
        }
    };

    useEffect(() => {
        // Function to generate a random file name
        const getRandomVideoFile = () => {
            const totalFiles = 3; // Adjust this number based on the total number of video files available
            const randomNumber = Math.floor(Math.random() * totalFiles) + 1;
            // return `/video/${randomNumber}.mp4`;
            return `/video/4.mp4`;
        };

        // Set the random video source
        setVideoSrc(getRandomVideoFile());
        document.addEventListener('mouseup', handleClickOutside);
        return () => {
            document.removeEventListener('mouseup', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (devices > 1) {
            setOpenMenu(true);
        }
    }, [devices])

    useEffect(() => {
        if (punish === 2 || punish === 3) {
            logout();
        }
        if (punish !== 1) return;
        const playVideoWithSound = () => {
            if (videoRef.current) {
                // Attempt to autoplay with sound
                videoRef.current.play().catch(error => {
                    console.error('Autoplay failed, user interaction required:', error);
                });
            }
        };

        const handlePlay = () => {
            setIsPlaying(true); // Update play state
            handleVolumeAndPlayState();
        };

        const handlePause = () => {
            setIsPlaying(false); // Update play state
            handleVolumeAndPlayState();
        };

        const handleVolumeChange = () => {
            if (videoRef.current) {
                if (videoRef.current.volume < 1) {
                    videoRef.current.muted = false;
                    videoRef.current.volume = 1;
                }
                handleVolumeAndPlayState();
            }
        };

        if (videoRef.current) {
            videoRef.current.addEventListener('play', handlePlay);
            videoRef.current.addEventListener('pause', handlePause);
            videoRef.current.addEventListener('volumechange', handleVolumeChange);
            // Initial check
            handleVolumeChange();
        }

        // Handle user interaction events (click, keydown, scroll, etc.)
        const handleUserInteraction = () => {
            if (videoRef.current) {
                videoRef.current.muted = false; // Ensure the video is not muted
                videoRef.current.play().then(() => {
                    console.log('Video successfully played through user interaction');
                }).catch(error => {
                    console.error('Playback failed:', error);
                });

                // Remove event listeners to prevent multiple triggers
                document.removeEventListener('touchstart', handleUserInteraction);
                document.removeEventListener('click', handleUserInteraction);
                document.removeEventListener('keydown', handleUserInteraction);
                document.removeEventListener('scroll', handleUserInteraction);
            }
        };

        // Bind event listeners: user click, keydown, or scroll can trigger playback
        document.addEventListener('touchstart', handleUserInteraction);
        document.addEventListener('click', handleUserInteraction);
        document.addEventListener('keydown', handleUserInteraction);
        document.addEventListener('scroll', handleUserInteraction);

        return () => {
            if (videoRef.current) {
                videoRef.current.removeEventListener('play', handlePlay);
                videoRef.current.removeEventListener('pause', handlePause);
                videoRef.current.removeEventListener('volumechange', handleVolumeChange);
            }
            // Clean up event listeners
            document.removeEventListener('touchstart', handleUserInteraction);
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('keydown', handleUserInteraction);
            document.removeEventListener('scroll', handleUserInteraction);
        };
    }, [isPlaying, punish]);


    useEffect(() => {
        fetchMessage();
        const fetchInterval = setInterval(fetchMessage, 10000); // Fetch every 10 seconds
        // Cleanup function to clear the interval when the component unmounts
        return () => clearInterval(fetchInterval);
    }, [location.pathname]);

    const ReturnFunctionExecute = () => {
        if (returnFunction) {
            setTargetReturn(true);
        } else {
            navigate(-1);
        }
    }

    const handleClickOutside = (event) => {
        if (navAdminSubNavRef.current && navAdminSubNavRef.current.contains(event.target)) {
            localStorage.setItem('LastOpenMenu', 'Admin');
            setPrimaryTab('Admin');
            if (devices <= 1) {
                setOpenMenu(false);
            }
        }
        if (phoneMoreBtnRef.current && !phoneMoreBtnRef.current.contains(event.target)) {
            setPhoneShowMore(false);
        }
    };

    const togglePrimaryNav = (primaryTab) => {
        if (secondaryBar !== primaryTab) {
            setSecondaryBar(primaryTab);
        } else {
            setSecondaryBar(null);
        }
    }

    const logout = () => {
        localStorage.clear();
        navigate("/login", { replace: true });
    }

    let currentUserRole;
    let userName;

    if (localStorage.getItem("user")) {
        try {
            currentUserRole = localStorage.getItem("role");
            userName = JSON.parse(localStorage.getItem("user")).UserName;

        } catch (error) {
            console.error("Error parsing user data:", error);
        }
    }

    const fetchMessage = async () => {
        currentUserRole = localStorage.getItem("role");
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
            console.log("No user found in local storage");
            return;
        }
        userName = user.UserName;
        try {
            const response = await axiosInstance.get(`${apiUrl}/api/getMessage/${userName}/${currentUserRole}/count`);
            const punish = await axiosInstance.get(`${apiUrl}/api/getJudgement/${userName}`);
            // console.log(response.data);
            setMessage(response.data[0].count);
            if (punish.data[0].Judgement === 2 || punish.data[0].Judgement === 3)
                logout();
            setPunish(punish.data[0].Judgement);
        } catch (err) {
            console.error(err);
        }
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const requiredPassword = "感谢您的大恩大德！！！";
        if (password === requiredPassword) {
            axiosInstance.post(`${apiUrl}/api/updateJudgement/${userName}`);
            alert('Thank you for your kindness.');
        } else {
            setPassword("");
            setPassword("");
            alert('Incorrect password. Please try again.');
        }
    };

    const HomeRouteByUserType = () => {
        switch (user.UserType) {
            default:
                navigate("/HomePage");
        }
    }

    const noSubBarChoice = (value) => {
        setSecondaryBar(null);
        setPrimaryTab(value);
        localStorage.setItem('LastOpenMenu', value);
    }


    return (
        <div className={`containerNav`}>
            {(currentUserRole) &&
                <nav className={`containerNav-navbar ${openMenu ? '' : 'will-expand'}`} style={{ display: `${openMenu ? '' : 'none'}` }}>
                    <div className="flex flex-col w-auto h-screen nav-bar-basic items-center">
                        {devices <= 1 && (<Link className="relative p-2" id="loginUser">{t('Hi,')}{" " + userName}
                        </Link>)}
                        {/* {(user.UserType === 'SuperAdmin') &&
                            <div className="mt-4 pb-2 px-2 location-selection">
                                <select
                                    className="max-w-20"
                                    id="location-select"
                                    value={selectedLocation ?? 'ALL'}
                                    onChange={e => { setSelectedLocation(e.target.value); }}
                                >
                                    {locationData.map((location, index) => (
                                        <option key={index} value={location.LocationCode}>
                                            {getRelativeLocationName(location.LocationCode)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        } */}

                        <nav className="mt-4 flex flex-col justify-between flex-1 content-inside-sidebar">
                            <div className="only-side-bar-navigate">
                                {devices > 1 &&
                                    (<>
                                        <div className="flex flex-col items-center justify-center p-2 hover:bg-HoverBlue" onClick={() => { HomeRouteByUserType(); noSubBarChoice(''); }}>
                                            <FaHome />
                                            <span className="ml-2">{t('Home')}</span>
                                        </div>
                                    </>)}
                                {(user.UserType.includes('Admin')) && <Link
                                    className={`flex items-center p-2 hover:bg-HoverBlue ${primaryTab === 'Admin' && 'primary-selected-color'}`}
                                    onClick={() => {
                                        togglePrimaryNav('Admin');
                                    }}
                                >
                                    <RiAdminFill />
                                    <span className="ml-2">{t('Admin')}</span>
                                </Link>}
                                <div ref={navAdminSubNavRef} >
                                    <SecondaryNav isOpen={secondaryBar === 'Admin'} PrimaryTab={'Admin'} />
                                </div>
                            </div>


                            {devices > 1 && (<div className="sidebar-bottom-part">
                                <Link className="relative p-2" id="loginUser">
                                    {" " + userName}
                                </Link>
                                <Link
                                    to="/MessagePage"
                                    className={`relative flex items-center p-2 hover:bg-HoverBlue ${primaryTab === 'Message' && 'primary-selected-color'}`}
                                    aria-label="Messages"
                                    onClick={() => {
                                        noSubBarChoice('Message')
                                        if (devices <= 1) {
                                            setOpenMenu(false);
                                        }
                                    }}
                                >
                                    <li className="relative">
                                        <FaEnvelope style={{ fontSize: '1.5rem' }} color="white" />
                                        {messages >= 1 && (
                                            <span
                                                className="absolute bg-red-500 text-white text-xs flex items-center justify-center rounded-full"
                                                style={{
                                                    width: '1rem',
                                                    height: '1rem',
                                                    top: '0.25rem',
                                                    right: '0.1rem',
                                                    fontSize: '0.75rem',
                                                    transform: 'translate(50%, -50%)',
                                                }}
                                            >
                                                {messages}
                                            </span>
                                        )}
                                    </li>
                                </Link>
                                <Link className={`flex items-center p-2 hover:bg-HoverBlue ${primaryTab === 'Profile' && 'primary-selected-color'}`}
                                    to="/profile"
                                    onClick={() => {
                                        noSubBarChoice('Profile');
                                        if (devices <= 1) {
                                            setOpenMenu(false);
                                        }
                                    }}>
                                    <FaUserCircle className="size-5 font-bold" />
                                </Link>
                            </div>)}
                        </nav>
                    </div>
                </nav >
            }
            {user?.UserType && (
                devices <= 1 && (<div className="shadow-lg flex justify-around phone-navbar">
                    <div className="flex items-center flex-col p-2 nav-return-btn" onClick={() => { ReturnFunctionExecute() }}>
                        <RiArrowGoBackFill />
                    </div>
                    <div onClick={() => { HomeRouteByUserType(); setOpenMenu(false); noSubBarChoice('') }}  >
                        <FaHome />
                    </div>
                    <div onClick={() => setOpenMenu(prev => !prev)} >
                        <FaBars />
                    </div>
                    <div className="relative" onClick={() => { setPhoneShowMore(prev => !prev) }}>
                        <CiCircleMore />
                        {messages >= 1 && (
                            <span
                                className="absolute bg-red-500 text-white text-xs flex items-center justify-center rounded-full"
                                style={{
                                    width: '0.5rem',
                                    height: '0.5rem',
                                    top: '0.25rem',
                                    right: '0.1rem',
                                    fontSize: '0.75rem',
                                    transform: 'translate(50%, -50%)',
                                }}
                            />
                        )}
                    </div>
                    {phoneShowMore && (
                        <div ref={phoneMoreBtnRef} className="absolute bottom-16 shadow-lg p-2 flex flex-col items-center space-y-2 animate-slide-up phone-more-btn-part">
                            <Link
                                to="/MessagePage"
                                className={`relative flex items-center p-2 hover:bg-HoverBlue`}
                                aria-label="Messages"
                                onClick={() => {
                                    noSubBarChoice('Message')
                                    setOpenMenu(false);
                                    setPhoneShowMore(false);
                                }}
                            >
                                <li className="relative">
                                    <FaEnvelope style={{ fontSize: '1.5rem' }} color="white" />
                                    {messages >= 1 && (
                                        <span
                                            className="absolute bg-red-500 text-white text-xs flex items-center justify-center rounded-full"
                                            style={{
                                                width: '1rem',
                                                height: '1rem',
                                                top: '0.25rem',
                                                right: '0.1rem',
                                                fontSize: '0.75rem',
                                                transform: 'translate(50%, -50%)',
                                            }}
                                        >
                                            {messages}
                                        </span>
                                    )}
                                </li>
                            </Link>
                            <div
                                onClick={() => {
                                    noSubBarChoice('Profile');
                                    setOpenMenu(false);
                                    navigate("/Profile")
                                }}>
                                <FaUserCircle />
                            </div>
                        </div>
                    )}
                </div>)
            )}
        </div>
    );
}

export default Nav;